// extracted by mini-css-extract-plugin
export default {"invalid-error":"HullFranchiseForm_invalid-error__LGX7T","submitBtn":"HullFranchiseForm_submitBtn__hbMCE"};